import { sortSelectStyles as styles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { FormFieldIcon } from "@insite/mobius/FormField/FormField";
import { commonInputIcons } from "@solveindustrial/Utilities/styleguide/FormFields/formField";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.select = {
    ...styles.select,
    sizeVariant: "small",
    cssOverrides: {
        ...styles.select?.cssOverrides,
        formField: css`
            ${styles.select?.cssOverrides?.formField};
            display: flex;
            justify-content: flex-start;
            align-items: center;

            ${mediaQueriesBP.minMD} {
                justify-content: flex-end;
            }

            select:not(.react-datetime-picker__inputGroup__input) {
                border-radius: 4px;
            }

            ${FormFieldIcon} {
                ${commonInputIcons};

                ${mediaQueriesBP.minMD} {
                    width: 30px;
                    height: 30px;
                }
            }
        `,
        formInputWrapper: css`
            ${styles.select?.cssOverrides?.formInputWrapper};
            width: auto;
        `,
    },
};
